import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { EstrategiaToast } from "../../estrategia/estrategia-toast/estrategia-toast.service";

@Injectable({ providedIn: 'root' })
export class LayoutEventsService {

    onLoginChange: EventEmitter<any>;

    onTipoIntegracaoEnvioAtualizar: EventEmitter<any>;

    private api: string;

    constructor(private httpClient: HttpClient) {
        this.onLoginChange = new EventEmitter();
        this.onTipoIntegracaoEnvioAtualizar = new EventEmitter();
        this.onEstrategiaExecutandoChange = new EventEmitter();
    }

    onEstrategiaExecutandoChange: EventEmitter<any>;


    private estrategiaExecutandoSubject = new BehaviorSubject<EstrategiaToast>(null);

    estrategiaExecutandoSubject$ = this.estrategiaExecutandoSubject.asObservable();

    setEstrategiaExecutando(value: EstrategiaToast) {
        this.estrategiaExecutandoSubject.next(value);
    }
}